// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3jfgl","label":"Radio_label__1-cf-","checkMark":"Radio_checkMark__3Kq9s","disabled":"Radio_disabled__3v0BQ"};